'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _size = require('lodash/size');

var _size2 = _interopRequireDefault(_size);

var _first = require('lodash/first');

var _first2 = _interopRequireDefault(_first);

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FallbackImageLoader = function (_React$Component) {
    _inherits(FallbackImageLoader, _React$Component);

    function FallbackImageLoader() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, FallbackImageLoader);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FallbackImageLoader.__proto__ || Object.getPrototypeOf(FallbackImageLoader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            loaded: false,
            shouldAttemptFallback: false,
            failedFallbacks: []
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(FallbackImageLoader, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadImage();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var loaded = this.state.loaded;

            if (prevProps.src !== this.props.src && loaded) {
                this.setState({
                    loaded: false,
                    shouldAttemptFallback: false
                });
            }
            if (!loaded) {
                this.loadImage();
            }
        }
    }, {
        key: 'isFallback',
        value: function isFallback() {
            return !(0, _isUndefined2.default)(this.props.fallback) && this.state.shouldAttemptFallback;
        }
    }, {
        key: 'getNextFallback',
        value: function getNextFallback() {
            var fallback = this.props.fallback;

            if (!(0, _isArray2.default)(fallback)) {
                return fallback;
            }
            return (0, _first2.default)((0, _difference2.default)(fallback, this.state.failedFallbacks));
        }
    }, {
        key: 'getImageSource',
        value: function getImageSource() {
            var src = this.props.src;

            var fallback = this.getNextFallback();
            return this.isFallback() ? fallback : src;
        }
    }, {
        key: 'loadImage',
        value: function loadImage() {
            var _this2 = this;

            var image = new Image();
            image.onload = function () {
                return _this2.onLoad();
            };
            image.onerror = function () {
                return _this2.onError();
            };
            image.src = this.getImageSource();
        }
    }, {
        key: 'onLoad',
        value: function onLoad() {
            this.setState({ loaded: true });
        }
    }, {
        key: 'getIsLoaded',
        value: function getIsLoaded() {
            var fallback = this.props.fallback;
            var _state = this.state,
                failedFallbacks = _state.failedFallbacks,
                shouldAttemptFallback = _state.shouldAttemptFallback;

            if ((0, _isArray2.default)(fallback)) {
                return shouldAttemptFallback && (0, _size2.default)(failedFallbacks) === (0, _size2.default)(fallback);
            }
            return shouldAttemptFallback;
        }
    }, {
        key: 'onError',
        value: function onError() {
            var fallback = this.props.fallback;

            var changes = { loaded: true };
            if (!(0, _isUndefined2.default)(fallback)) {
                var loaded = this.getIsLoaded();
                changes.shouldAttemptFallback = true;
                changes.loaded = loaded;
                if ((0, _isArray2.default)(fallback) && !loaded) {
                    changes.failedFallbacks = [].concat(_toConsumableArray(this.state.failedFallbacks), [this.getImageSource()]);
                }
            }
            this.setState(changes);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                alt = _props.alt,
                imgClassName = _props.imgClassName,
                className = _props.className,
                isCover = _props.isCover,
                isCoverForFallback = _props.isCoverForFallback;
            var loaded = this.state.loaded;

            var isFallback = this.isFallback();
            var src = this.getImageSource();
            var useCover = !isFallback && isCover || isFallback && isCover && isCoverForFallback !== false;
            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('cc-fallback-image-loader-comp', className, { loaded: loaded }) },
                useCover ? _react2.default.createElement(
                    _react.Fragment,
                    null,
                    loaded && _react2.default.createElement(
                        'span',
                        { className: 'cc-fallback-image-loader-alt' },
                        alt
                    ),
                    _react2.default.createElement('div', { className: (0, _classnames2.default)("cc-fallback-image-loader-image", imgClassName),
                        style: {
                            backgroundImage: !loaded ? 'none' : 'url(' + src + ')'
                        } })
                ) : _react2.default.createElement('img', { className: (0, _classnames2.default)("cc-fallback-image-loader-image", imgClassName),
                    alt: alt,
                    src: src
                })
            );
        }
    }]);

    return FallbackImageLoader;
}(_react2.default.Component);

FallbackImageLoader.propTypes = {
    src: _propTypes2.default.string.isRequired,
    imgClassName: _propTypes2.default.string,
    fallback: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
    alt: _propTypes2.default.string,
    className: _propTypes2.default.string,
    isCover: _propTypes2.default.bool,
    isCoverForFallback: _propTypes2.default.bool
};
FallbackImageLoader.defaultProps = {
    isCover: false
};
exports.default = FallbackImageLoader;
//# sourceMappingURL=index.js.map